import Hackathon from './hackathon.template';
import Demo from './demo.template';

export const DATA_TEMPLATES = { Hackathon, Demo };
